import { useQuery } from '@tanstack/react-query';
import { getMemberListing } from 'api';

export default function useMemberListWithCache() {
  const didListRequest = useQuery({
    queryFn: ({ queryKey }) => getMemberListing(queryKey[1] || {}),
    queryKey: ['getMemberListingWithCache', { limit: 1000 }],
    refetchOnMount: false,
  });

  return { ...didListRequest };
}
